import { useEffect } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerPostulacion } from "../components/BannerPostulacion";
import { Footer } from "../../../components/Landing/Footer";
// Hooks
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import { useSeleccionarRoles } from "../../../hooks/useSeleccionarRoles";
// style component
import { Checkbox, Radio, Button } from "antd";
// style
import "../Usuario.style.scss";
// readux
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
// data select
import { ObjNotificaciones } from "../../../config/notificaciones";
import { useNavigate } from "react-router-dom";

export const SeleccionarRoles = () => {
  const participante = useSelector((state: RootState) => state.participantes);
  const navigate = useNavigate();
  const { getConvocatoriaPersistente, convocatoriaPersitente: convocatoria } =
    UseVerConvocatorias();
  const {
    principalState,
    setPrincipalState,
    cambioCheckBox,
    asociarRoles,
  } = useSeleccionarRoles();
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (participante.datos_postulacion.principalState) {
        console.log(participante.datos_postulacion.principalState);
        setPrincipalState({
          Gestor: participante.datos_postulacion.principalState.Gestor,
          Creador: participante.datos_postulacion.principalState.Creador,
          tipo_participante:
            participante.datos_postulacion.principalState.tipo_participante,
        });
      }

      getConvocatoriaPersistente();
    }
    return () => {
      mounted = false;
    };
  }, []);

  let natural;
  let juridica;
  let conformado;

  if (convocatoria.tipo_participante?.length > 0) {
    natural = convocatoria.tipo_participante.find(
      (x) => x.text == "Persona natural"
    );
    juridica = convocatoria.tipo_participante.find(
      (x) => x.text == "Persona jurídica"
    );
    conformado = convocatoria.tipo_participante.find(
      (x) => x.text == "Grupo conformado"
    );
  }

  return (
    <div style={{ height: "100vh" }}>
      <Header />
      <BannerPostulacion convocatorias={convocatoria} />
      <div className="container-fluid2">
        <div className="row">
          <div className="row pt-4">
            <div className="col-12 no-margin font-family-Montserrat-Regular font-size-18px">
              <span className="font-family-Montserrat-SemiBold">
                ¡GENIAL! Estás a punto de postularte en la convocatoria.
              </span>{" "}
              Por favor completa los siguientes datos. Recuerda que todos los
              campos son obligatorios.
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-2 ms-2 text-center font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion">
              1
            </div>
            <div className="col ps-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
              Datos personales
            </div>
          </div>
          <div className="row mt-4">
            <div>
              <div className="col-12 mb-2 font-size-12px font-family-Montserrat-Bold font-color-4B4B4B">
                Tipo de participante
              </div>
              <div className="col-12">
                <Radio.Group
                  defaultValue={principalState.tipo_participante}
                  onChange={(e) =>
                    setPrincipalState({
                      ...principalState,
                      tipo_participante: e.target.value,
                    })
                  }
                >
                  {natural && (
                    <Radio
                      className="font-family-Montserrat-Regular"
                      value={natural.value}
                    >
                      {natural.text}
                    </Radio>
                  )}
                  {juridica && (
                    <Radio
                      className="font-family-Montserrat-Regular"
                      value={juridica.value}
                    >
                      {juridica.text}
                    </Radio>
                  )}
                  {conformado && (
                    <Radio
                      className="font-family-Montserrat-Regular"
                      value={conformado.value}
                    >
                      {conformado.text}
                    </Radio>
                  )}
                  {/* {QuienParticipaOptions.map(({ value, text }) => (

              ))} */}
                </Radio.Group>
              </div>

              {principalState.tipo_participante !== 3 ? (
                <div className="col-12 font-size-12px font-family-Montserrat-Regular">
                  <div className="col-12 mt-4 mb-1 font-size-12px font-family-Montserrat-Bold font-color-4B4B4B">
                    ¿Usted es gestor o creador de contenido?
                  </div>
                  <Checkbox
                    checked={principalState.Gestor}
                    onChange={(e) => cambioCheckBox(e, "Gestor")}
                  >
                    Gestor
                  </Checkbox>
                  <Checkbox
                    checked={principalState.Creador}
                    onChange={(e) => cambioCheckBox(e, "Creador")}
                  >
                    Creador
                  </Checkbox>
                </div>
              ) : null}
            </div>
          </div>
          <div
            className="row"
            style={{
              width: "100%",
              justifyContent: "center",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            <div className="col-12 justify-content-end d-flex">
              <Button style={{ marginRight: "1%" }} className="button-blanco-radius font-size-12px" onClick={() => navigate(-1)}>
                Atrás
              </Button>
              <Button
                className="button-azul-radius font-size-12px"
                onClick={() => principalState.tipo_participante ? asociarRoles(principalState.tipo_participante) : ObjNotificaciones.MSG_ERROR('warning', 'Formulario incompleto', 'Por favor, selecciona un tipo participante')}
              >
                Continuar
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
